import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetInvoicesInput } from '../domain/dtos/get-invoices-input'
import { GetInvoicesOutput } from '../domain/dtos/get-invoices-output'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetInvoices {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: GetInvoicesInput): Promise<GetInvoicesOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_WEB_URL}/subscriptions/${input.subscriptionId}/invoices`,
      params: this.makeParams(input),
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data
    }

    throw new GeneralError()
  }

  private makeParams(input: GetInvoicesInput) {
    const body = {
      page: input.page,
      pageSize: input.pageSize,
    }

    return body
  }
}
